/* eslint-disable react/jsx-no-useless-fragment */
import { Box, Flex, Text, Icon, HStack } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { FiInfo } from "react-icons/fi";

const Banner = () => {
  const [bannerUpdated, setBannerUpdated] = useState("");
  const [bannerContent, setBannerContent] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const results = await axios.get(
          `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/items/web_banner`
        );

        const { data } = results.data;

        if (data.content && data.date_updated) {
          setBannerUpdated(data.date_updated);
          setBannerContent(data.content);
        }
      } catch (error) {
        // Silently fail - banner is optional content
      }
    })();
  }, []);

  if (bannerUpdated === "" || bannerContent === "") {
    return null;
  }

  return (
    <Box
      margin="0 auto"
      maxWidth="100vw"
      transition="0.3s ease-out"
      position="relative"
      zIndex={10}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <Flex
        align="center"
        justify="center"
        w="100%"
        bgGradient="linear(to-r, brand.500, brand.700)"
        color="white"
        py={2.5}
        px={8}
      >
        <HStack spacing={2}>
          <Icon as={FiInfo} boxSize={4} aria-hidden="true" />
          <Text fontWeight={600} textAlign="center" fontSize="sm">
            {bannerContent}
          </Text>
        </HStack>
      </Flex>
    </Box>
  );
};

export default Banner;
